import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import styles from '../../assets/jss/pages/CartViewerStyle';
import FormDialog from '../../components/Dialog/FormDialog';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import Typography from '../../components/Typography/CustomTypography';
import { headerTableOrder, lavenderTableOrder } from '../../assets/jss/global';
import TableProductPaymentDetail from '../../components/TableProductPaymentDetail/TableProductPaymentDetail';
import Button from '../../components/Button/CustomButton';

const useStyles = makeStyles(styles);

const DialogHistoryOrderProduct = ({
    isOpen,
    handleClose,
    idHistoryOrder,
    clearDetailHistoryProduct,
    getDetailHistoryProduct,
    listProductOrder,
    customText,
    customColor,
    locale,
    isLoading,
}) => {
    const classes = useStyles(customColor);
    const intl = useIntl();
    const { shortName } = useParams();
    const [listProduct, setListProduct] = useState([]);
    const [titleProduct, setTitleProduct] = useState([]);
    const [listSellProduct, setListSellProduct] = useState([]);

    useEffect(() => {
        if (isOpen && idHistoryOrder) {
            getDetailHistoryProduct({ event_name: shortName, transaction_id: idHistoryOrder, language: locale });
        } else {
            clearDetailHistoryProduct();
        }
    }, [idHistoryOrder, isOpen, locale]);

    useEffect(() => {
        if (!_.isEmpty(listProductOrder)) {
            setListProduct(listProductOrder.data);
        }
    }, [listProductOrder]);

    useEffect(() => {
        if (listProduct) {
            allSellProduct();
            titleSellProduct();
        }
    }, [listProduct]);

    const titleSellProduct = () => {
        const title = listProduct.map((item) => [item.full_name]);
        setTitleProduct(title);
    };

    const sellProduct = (data) => {
        const product = [];
        (data.products || []).forEach((item) => {
            product.push([
                item.name,
                `${item.price}${intl.formatMessage({ id: 'common.yen' })}`,
                +item.quantity,
            ]);
        });
        product.push([
            intl.formatMessage({ id: 'shopping.postage' }),
            `${data.shipping_cost}${intl.formatMessage({ id: 'common.yen' })}`, '']);
        product.push([
            intl.formatMessage({ id: 'shopping.subtotal' }),
            `${data.price_total}${intl.formatMessage({ id: 'common.yen' })}`, data.quantity_total]);
        return product;
    };

    const allSellProduct = () => {
        const allSell = listProduct.map((item) => sellProduct(item));
        setListSellProduct(allSell);
    };

    const registerAction = () => (
        <GridContainer
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Button
                color="navy"
                round
                gradient
                className={classes.buttonSmall}
                onClick={handleClose}
                buttonTextColor={customColor?.button_text_color}
                buttonBackgroundColor={customColor?.button_background_color?.common_button}
            >
                <b>{customText?.button_name?.close_up || intl.formatMessage({ id: 'common.close' })}</b>
            </Button>
        </GridContainer>
    );

    return (
        <>
            <FormDialog
                title={intl.formatMessage({ id: 'shopping.orderDetail' })}
                titleAlign="center"
                isOpen={isOpen}
                handleClose={handleClose}
                actions={registerAction()}
                customColor={customColor?.contents_text_color}
            >
                <div>
                    <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                        <GridItem>
                            <Paper elevation={3} classes={{ root: classes.room }}>
                                <GridItem xs={12} md={12} className={classes.titleDetail}>
                                    <Typography variant="h6" customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'shopping.breakdown' })}
                                    </Typography>
                                </GridItem>
                                <GridItem xs={12} md={12}>
                                    {!_.isEmpty(listSellProduct) && !isLoading && (
                                        <TableProductPaymentDetail
                                            cellColor={customColor?.shop_table?.title_background_color || headerTableOrder}
                                            colorRowTitle={customColor?.shop_table?.sub_title_background_color || lavenderTableOrder}
                                            onClick={() => {}}
                                            tableHead={[
                                                customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                                                intl.formatMessage({ id: 'shopping.unitPrice' }),
                                                intl.formatMessage({ id: 'shopping.quantity' }),
                                            ]}
                                            tableHeadWidth={['60%', '25%', '15%']}
                                            tableTitleRow={titleProduct}
                                            tableData={listSellProduct}
                                            hover={false}
                                            pointerLess
                                            className={classes.customTable}
                                            lengthCol={3}
                                            cellBackgroundColor={customColor?.shop_table?.record_background_color}
                                            cellTextColorHear={customColor?.contents_text_color}
                                            cellTextColorBody={customColor?.contents_text_color}
                                        />
                                    )}
                                </GridItem>
                            </Paper>
                        </GridItem>
                        { listProductOrder.payment_method === '銀行口座' && (
                            <GridItem xs={12} md={12} className={classes.titleDetail}>
                                <Typography variant="h6" className={classes.invoiceNumber} customColor={customColor?.contents_text_color}>
                                    {`${intl.formatMessage({ id: 'shopping.invoiceNumber' })} : ${listProductOrder.invoice_number}`}
                                </Typography>
                            </GridItem>
                        )}
                        <GridItem xs={12} md={12} style={{ padding: '15px 0' }}>
                            <Typography variant="h6" className={classes.totalPrice} customColor={customColor?.contents_text_color}>
                                {`${
                                    intl.formatMessage({ id: 'shopping.totalInvoice' })
                                }: ${listProductOrder.all_total_price}${intl.formatMessage({ id: 'common.yen' })}`}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                </div>
            </FormDialog>
        </>
    );
};

DialogHistoryOrderProduct.defaultProps = {
    isOpen: false,
    handleClose: () => {},
    idHistoryOrder: null,
    clearDetailHistoryProduct: () => {},
    getDetailHistoryProduct: () => {},
    listProductOrder: {},
    customText: {},
    customColor: {},
    locale: 'ja',
    isLoading: false,
};

DialogHistoryOrderProduct.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    idHistoryOrder: PropTypes.number,
    clearDetailHistoryProduct: PropTypes.func,
    getDetailHistoryProduct: PropTypes.func,
    listProductOrder: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default DialogHistoryOrderProduct;
